<template>
    <!-- Tablero por estado (demo: js/board.js). Arrastrar: mouse (o pulsación larga
         en táctil); Mayús + ← → con el teclado; menú "Mover a…" en cada tarjeta.
         Cada columna muestra 50 tarjetas y carga 50 más al llegar al final. -->
    <div ref="wrap" class="cr-board-wrap">
        <div ref="board" class="cr-board" :class="{ 'is-col-drag': C && C.on }" :aria-label="crm.t('head.board')"
             @pointerdown="down" @keydown="tecla">
            <section v-for="(e, i) in estadosVista" :key="e.id" class="cr-col" :class="['tn-' + e.tn, { 'is-src-col': C && C.on && C.id === e.id, 'is-folded': plegada(e), 'is-over': D && D.on && D.to === e.id, 'is-from': D && D.on && D.from === e.id, 'is-flash-col': flashCol === e.id }]"
                     :data-est="e.id" :style="{ animationDelay: i * 30 + 'ms' }" :aria-label="crm.t('col.aria', { e: e.nombre, n: cols[e.id].length })"
                     @click="clicCol(e)">
                <header class="cr-col-head" :title="crm.t('col.drag')">
                    <span class="cr-col-name"><span class="cr-dot"></span><span>{{ e.nombre }}</span></span>
                    <span class="cr-col-n">{{ cols[e.id].length }}</span>
                    <span class="cr-col-tools">
                        <button type="button" class="cr-ico-btn cr-col-tool-add" :aria-label="crm.t('col.add_in', { e: e.nombre })" @click.stop="crm.nueva(e.id)" v-html="I.plus"></button>
                        <button type="button" class="cr-ico-btn" :aria-label="crm.t(plegada(e) ? 'col.unfold' : 'col.fold', { e: e.nombre })" @click.stop="crm.plegar(e.id)" v-html="I.fold"></button>
                    </span>
                </header>
                <div class="cr-col-body" :data-est="e.id">
                    <template v-for="c in visiblesCol(e)">
                        <div v-if="D && D.on && D.to === e.id && D.antes === c.id" :key="'ph'" class="cr-cd-ph" :style="{ height: D.h + 'px' }"></div>
                        <article :key="c.id" class="cr-cd" :class="{ 'is-src': D && D.on && D.id === c.id, 'is-open': crm.abiertaId === c.id, 'is-flash': flash === c.id }"
                                 :data-id="c.id" tabindex="0" :aria-label="crm.t('card.aria', { n: c.empresa, e: e.nombre })" @click="clic(c, $event)">
                            <div class="cr-cd-top">
                                <span v-html="crm.priPill(c.prioridad)"></span>
                                <span v-if="c.seguimiento" class="cr-cd-follow" :class="{ 'is-due': crm.segVencido(c) }" :title="crm.t('p.follow')"><span v-html="I.flag"></span>{{ fechaCorta(c.seguimiento) }}</span>
                                <span class="cr-cd-sp"></span>
                                <span v-if="c.asignado" v-html="crm.avHTML(c.asignado, 'cr-av--s')"></span>
                                <button type="button" class="cr-ico-btn cr-cd-menu" :aria-label="crm.t('card.menu', { n: c.empresa })" aria-haspopup="menu" aria-expanded="false" @click.stop="crm.menuTarjeta($event, c)" v-html="I.more"></button>
                            </div>
                            <h3 class="cr-cd-name">{{ c.empresa }}</h3>
                            <p v-if="c.tipo" class="cr-cd-type">{{ c.tipo }}</p>
                            <div v-if="c.ciudades" class="cr-cd-row"><span v-html="I.pin"></span><span :title="c.ciudades">{{ c.ciudades }}</span></div>
                            <div class="cr-cd-row"><span v-html="I.user"></span>
                                <span v-if="c.contacto">{{ c.contacto }}<span v-if="c.cargo" class="cr-muted"> · {{ c.cargo }}</span></span>
                                <span v-else class="cr-muted">{{ crm.t('card.no_contact') }}</span>
                            </div>
                            <div class="cr-cd-links">
                                <component :is="l.href ? 'a' : 'span'" v-for="l in enlaces(c)" :key="l.k" class="cr-lk" :class="[l.cls, { 'cr-lk--off': !l.href }]"
                                           :href="l.href || null" :target="l.href ? '_blank' : null" :rel="l.href ? 'noopener' : null"
                                           :title="l.href ? l.t : null" :aria-label="l.href ? l.t : null" :aria-hidden="l.href ? null : 'true'" @click.stop v-html="l.ic"></component>
                            </div>
                            <div class="cr-cd-foot">
                                <span v-html="crm.avHTML(pie(c).q, 'cr-av--s')"></span>
                                <span :title="crm.fecha(pie(c).t)">{{ pie(c).accion }} <b>{{ crm.nombreDe(pie(c).q) }}</b> · {{ crm.rel(pie(c).t) }}</span>
                                <span class="cr-cd-age" :class="crm.edad(c).nivel ? 'is-' + crm.edad(c).nivel : ''" :title="crm.t('card.age')"><span v-html="I.clock"></span>{{ crm.edad(c).txt }}</span>
                            </div>
                        </article>
                    </template>
                    <div v-if="D && D.on && D.to === e.id && !D.antes && !plegada(e)" :key="'ph-end'" class="cr-cd-ph" :style="{ height: D.h + 'px' }"></div>
                    <p v-if="!cols[e.id].length && !(D && D.on && D.to === e.id)" class="cr-col-empty">{{ crm.hayFiltros ? crm.t('col.empty_f') : crm.t('col.empty') }}</p>
                    <button v-if="cols[e.id].length > limite(e)" :ref="'mas' + e.id" type="button" class="cr-col-more" :data-est="e.id" @click.stop="cargarMas(e.id)">{{ crm.t('col.more', { n: Math.min(PASO, cols[e.id].length - limite(e)) }) }}</button>
                </div>
                <button type="button" class="cr-col-add" @click.stop="crm.nueva(e.id)"><span v-html="I.plus"></span>{{ crm.t('tb.new') }}</button>
            </section>
        </div>
        <div v-if="C && C.on" class="cr-col-ghost" :class="'tn-' + C.tn" :style="{ width: C.w + 'px', transform: `translate(${C.x - C.dx}px, ${C.y - C.dy}px) rotate(1.5deg)` }" aria-hidden="true"><span class="cr-col-name"><span class="cr-dot"></span><span>{{ C.nombre }}</span></span><span class="cr-col-n">{{ C.n }}</span></div>
        <div v-if="D && D.on" ref="ghost" class="cr-cd cr-cd-ghost" :style="{ width: D.w + 'px', transform: `translate(${D.x - D.dx}px, ${D.y - D.dy}px) rotate(2.5deg) scale(1.02)` }" v-html="D.html"></div>
    </div>
</template>

<script>
import { I, urlOk } from './crmUtil';

const PASO = 50;

export default {
    name: 'CrmBoard',
    inject: ['crm'],
    data() { return { I, PASO, D: null, C: null, limites: {}, flash: null, flashCol: null }; },
    computed: {
        cols() { const m = {}; this.crm.estados.forEach(e => { m[e.id] = this.crm.enColumna(e.id); }); return m; },
        arrastrando() { return !!((this.D && this.D.on) || (this.C && this.C.on)); },
        /** Columnas en pantalla: mientras se arrastra una, en el orden provisorio. */
        estadosVista() { const C = this.C; return C && C.on ? C.orden.map(id => this.crm.estadoPorId[id]).filter(Boolean) : this.crm.estados; },
    },
    mounted() {
        this._move = e => { this.mover(e); this.moverCol(e); };
        this._up = () => { this.up(); this.upCol(); };
        this._cancel = () => {
            if (this.D) { clearTimeout(this.D.timer); if (this.D.on) this.fin(); this.D = null; }
            if (this.C) { clearTimeout(this.C.timer); cancelAnimationFrame(this.C.raf); this.C = null; document.documentElement.classList.remove('cr-dragging'); }
        };
        this._esc = e => {
            if (e.key === 'Escape' && this.D && this.D.on) { this.fin(); this.D = null; }
            if (e.key === 'Escape' && this.C && this.C.on) { cancelAnimationFrame(this.C.raf); this.C = null; document.documentElement.classList.remove('cr-dragging'); }
        };
        this._touch = e => { if ((this.D && this.D.on) || (this.C && this.C.on)) e.preventDefault(); };
        addEventListener('pointermove', this._move, { passive: false });
        addEventListener('pointerup', this._up);
        addEventListener('pointercancel', this._cancel);
        addEventListener('keydown', this._esc);
        addEventListener('touchmove', this._touch, { passive: false });
        // Al acercarse al final de una columna (400 px antes) se cargan 50 tarjetas más.
        if ('IntersectionObserver' in window) {
            this._io = new IntersectionObserver(ents => {
                ents.forEach(en => { if (en.isIntersecting) this.cargarMas(Number(en.target.dataset.est)); });
            }, { root: this.$refs.board, rootMargin: '0px 400px 400px 0px' });
        }
        this.$nextTick(this.observar);
    },
    updated() { this.observar(); },
    beforeDestroy() {
        removeEventListener('pointermove', this._move);
        removeEventListener('pointerup', this._up);
        removeEventListener('pointercancel', this._cancel);
        removeEventListener('keydown', this._esc);
        removeEventListener('touchmove', this._touch);
        if (this._io) this._io.disconnect();
        if (this.D) cancelAnimationFrame(this.D.raf);
        document.documentElement.classList.remove('cr-dragging');
    },
    methods: {
        plegada(e) { return this.crm.plegadas.includes(e.id); },
        limite(e) { return this.limites[e.id] || PASO; },
        visiblesCol(e) { return this.plegada(e) ? [] : this.cols[e.id].slice(0, this.limite(e)); },
        cargarMas(id) {
            const n = (this.cols[id] || []).length, lim = this.limites[id] || PASO;
            if (lim < n) this.$set(this.limites, id, lim + PASO);
        },
        /** Vuelve a mirar los botones "Mostrar más": al observar, el navegador avisa
         *  si ya están a la vista (así se sigue cargando si la pantalla es alta). */
        observar() {
            if (!this._io || !this.$refs.board) return;
            this._io.disconnect();
            this.$refs.board.querySelectorAll('.cr-col-more').forEach(b => this._io.observe(b));
        },
        fechaCorta(d) { const [y, m, dd] = d.split('-').map(Number); return new Date(y, m - 1, dd).toLocaleDateString(this.crm.loc, { day: 'numeric', month: 'short' }); },
        enlaces(c) {
            const t = this.crm.t;
            return [
                { k: 'w', href: urlOk(c.web), ic: I.web, t: t('fld.web') },
                { k: 'm', href: c.email ? 'mailto:' + c.email : '', ic: I.mail, t: t('fld.email') + ' ' + (c.email || '') },
                { k: 'p', href: urlOk(c.liP), ic: I.in, t: t('fld.liP'), cls: 'cr-lk--in' },
                { k: 'e', href: urlOk(c.liE), ic: I.in, t: t('fld.liE'), cls: 'cr-lk--in' },
            ];
        },
        pie(c) {
            if (c.movida) return { q: c.movidaPor, t: c.movida, accion: this.crm.t('card.moved_by') };
            const u = c.ultimo || {};
            // Lo que se cargó junto con la tarjeta (asignación, seguimiento, primera nota) no cuenta como edición.
            if (u.ty && u.ty !== 'new' && u.t !== c.creada) return { q: u.q, t: u.t, accion: this.crm.t('card.edited_by') };
            return { q: c.creadaPor, t: c.creada, accion: this.crm.t('card.loaded_by') };
        },
        clic(c, e) {
            if (e.target.closest('a, button')) return;
            if (Date.now() - (this._finArrastre || 0) < 250) return;
            this.crm.abrir(c.id);
        },
        resaltar(id, centrar) {
            // Si la tarjeta quedó más abajo de lo cargado, se carga hasta ella.
            const c = this.crm.tarjeta(id), lista = c && this.cols[c.estado];
            const i = lista ? lista.findIndex(t => t.id === id) : -1;
            if (i >= (this.limites[c && c.estado] || PASO)) this.$set(this.limites, c.estado, Math.ceil((i + 1) / PASO) * PASO);
            this.flash = id;
            clearTimeout(this._tf);
            this._tf = setTimeout(() => { this.flash = null; }, 1400);
            this.$nextTick(() => {
                const el = this.$refs.board && this.$refs.board.querySelector(`.cr-cd[data-id="${id}"]`);
                if (el) el.scrollIntoView({ block: 'nearest', inline: centrar ? 'center' : 'nearest', behavior: 'smooth' });
            });
        },

        clicCol(e) {
            if (Date.now() - (this._finArrastre || 0) < 250) return;
            if (this.plegada(e)) this.crm.plegar(e.id);
        },

        // ── Arrastrar columnas (desde la cabecera): cambia el orden para todo el equipo ──
        downCol(e, head) {
            const col = head.closest('.cr-col');
            this.C = { el: col, id: Number(col.dataset.est), x0: e.clientX, y0: e.clientY, x: e.clientX, y: e.clientY, on: false, touch: e.pointerType !== 'mouse' };
            if (this.C.touch) this.C.timer = setTimeout(() => { if (this.C && !this.C.on) this.empezarCol(); }, 320);
        },
        moverCol(e) {
            const C = this.C; if (!C) return;
            C.x = e.clientX; C.y = e.clientY;
            const lejos = Math.hypot(C.x - C.x0, C.y - C.y0) > 6;
            if (!C.on) {
                if (C.touch) { if (lejos) { clearTimeout(C.timer); this.C = null; } return; }
                if (!lejos) return;
                this.empezarCol();
            }
            e.preventDefault();
            this.seguirCol();
        },
        empezarCol() {
            const C = this.C, r = C.el.getBoundingClientRect(), est = this.crm.estado(C.id);
            this.C = { ...C, on: true, dx: C.x0 - r.left, dy: C.y0 - r.top, w: r.width, tn: est.tn, nombre: est.nombre, n: this.cols[C.id].length, orden: this.crm.estados.map(x => x.id), orig: this.crm.estados.map(x => x.id).join() };
            document.documentElement.classList.add('cr-dragging');
            this.crm.cerrarPop();
            if (navigator.vibrate && C.touch) navigator.vibrate(12);
            this.C.raf = requestAnimationFrame(this.autoCol);
        },
        seguirCol() {
            const C = this.C, b = this.$refs.board; if (!C || !C.on || !b) return;
            const otras = [...b.querySelectorAll(':scope > .cr-col')].filter(el => Number(el.dataset.est) !== C.id);
            const sig = otras.find(el => { const r = el.getBoundingClientRect(); return C.x < r.left + r.width / 2; });
            const ids = otras.map(el => Number(el.dataset.est));
            const i = sig ? ids.indexOf(Number(sig.dataset.est)) : ids.length;
            ids.splice(i, 0, C.id);
            if (ids.join() !== C.orden.join()) C.orden = ids;
        },
        autoCol() {
            const C = this.C, b = this.$refs.board; if (!C || !C.on || !b) return;
            const r = b.getBoundingClientRect(), antes = b.scrollLeft;
            if (C.x < r.left + 80) b.scrollLeft -= 16; else if (C.x > r.right - 80) b.scrollLeft += 16;
            if (b.scrollLeft !== antes) this.seguirCol();
            C.raf = requestAnimationFrame(this.autoCol);
        },
        upCol() {
            const C = this.C; if (!C) return;
            clearTimeout(C.timer); cancelAnimationFrame(C.raf);
            this.C = null;
            if (!C.on) return;
            document.documentElement.classList.remove('cr-dragging');
            this._finArrastre = Date.now();
            if (C.orden.join() !== C.orig) this.crm.ordenarEstados(C.orden, C.id);
        },
        // ── Arrastrar y soltar ──
        down(e) {
            if (e.button !== 0 || e.target.closest('a, button')) return;
            const head = e.target.closest('.cr-col-head');
            if (head) { this.downCol(e, head); return; }
            const cd = e.target.closest('.cr-cd'); if (!cd) return;
            this.D = { el: cd, id: Number(cd.dataset.id), x0: e.clientX, y0: e.clientY, x: e.clientX, y: e.clientY, on: false, touch: e.pointerType !== 'mouse' };
            if (this.D.touch) this.D.timer = setTimeout(() => { if (this.D && !this.D.on) this.empezar(); }, 320);
        },
        mover(e) {
            const D = this.D; if (!D) return;
            D.x = e.clientX; D.y = e.clientY;
            const lejos = Math.hypot(D.x - D.x0, D.y - D.y0) > 6;
            if (!D.on) {
                if (D.touch) { if (lejos) { clearTimeout(D.timer); this.D = null; } return; }
                if (!lejos) return;
                this.empezar();
            }
            e.preventDefault();
            this.seguir();
        },
        empezar() {
            const D = this.D, r = D.el.getBoundingClientRect(), col = D.el.closest('.cr-col');
            Object.assign(D, { on: true, dx: D.x0 - r.left, dy: D.y0 - r.top, w: r.width, h: r.height, html: D.el.innerHTML, from: Number(col.dataset.est), to: Number(col.dataset.est), antes: null });
            this.D = { ...D };
            document.documentElement.classList.add('cr-dragging');
            this.crm.cerrarPop();
            if (navigator.vibrate && D.touch) navigator.vibrate(12);
            this.seguir();
            this.D.raf = requestAnimationFrame(this.autoScroll);
        },
        seguir() {
            const D = this.D;
            const el = document.elementFromPoint(D.x, D.y), col = el && el.closest('.cr-col');
            if (!col) { D.to = null; D.antes = null; return; }
            D.to = Number(col.dataset.est);
            if (col.classList.contains('is-folded')) { D.antes = null; return; }
            const cds = [...col.querySelectorAll('.cr-cd:not(.is-src)')];
            const sig = cds.find(c => { const r = c.getBoundingClientRect(); return D.y < r.top + r.height / 2; });
            D.antes = sig ? Number(sig.dataset.id) : null;
        },
        autoScroll() {
            const D = this.D; if (!D || !D.on) return;
            const b = this.$refs.board, br = b.getBoundingClientRect(), m = 70;
            if (D.x < br.left + m) b.scrollLeft -= 14; else if (D.x > br.right - m) b.scrollLeft += 14;
            // Las columnas ya no tienen scroll propio: se desplaza el tablero hacia arriba/abajo.
            if (D.y < br.top + 60) b.scrollTop -= 14; else if (D.y > br.bottom - 60) b.scrollTop += 14;
            const el = document.elementFromPoint(D.x, D.y), body = el && el.closest('.cr-col') && el.closest('.cr-col').querySelector('.cr-col-body');
            if (body) { const r = body.getBoundingClientRect(); if (D.y < r.top + 50) body.scrollTop -= 12; else if (D.y > r.bottom - 50) body.scrollTop += 12; }
            D.raf = requestAnimationFrame(this.autoScroll);
        },
        fin() {
            cancelAnimationFrame(this.D.raf);
            document.documentElement.classList.remove('cr-dragging');
            this._finArrastre = Date.now();
        },
        up() {
            const D = this.D; if (!D) return;
            clearTimeout(D.timer);
            if (!D.on) { this.D = null; return; }
            this.fin();
            const { id, to, antes } = D;
            this.D = null;
            if (!to) return;
            const c = this.crm.tarjeta(id);
            const cs = this.crm.tarjetas.filter(t => t.estado === to && t.id !== id).sort((a, b) => a.orden - b.orden || a.id - b.id);
            let orden;
            if (antes) { const i = cs.findIndex(t => t.id === antes), p = cs[i - 1]; orden = p ? (p.orden + cs[i].orden) / 2 : cs[i].orden - 1; }
            else orden = cs.length ? cs[cs.length - 1].orden + 1 : 0;
            if (c.estado === to && antes === null && cs.length && c.orden > cs[cs.length - 1].orden) return;
            this.crm.mover(c, to, orden);
        },

        // ── Teclado ──
        tecla(e) {
            const cd = e.target.closest('.cr-cd'); if (!cd || e.target !== cd) return;
            const c = this.crm.tarjeta(Number(cd.dataset.id)), est = this.crm.estados;
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.crm.abrir(c.id); }
            else if (e.shiftKey && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
                e.preventDefault();
                const i = est.findIndex(x => x.id === c.estado), j = i + (e.key === 'ArrowRight' ? 1 : -1);
                if (est[j]) { this.crm.mover(c, est[j].id); this.$nextTick(() => { const el = this.$refs.board.querySelector(`.cr-cd[data-id="${c.id}"]`); if (el) el.focus(); }); }
            } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                const n = e.key === 'ArrowDown' ? cd.nextElementSibling : cd.previousElementSibling;
                if (n && n.classList.contains('cr-cd')) n.focus();
            } else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                const col = cd.closest('.cr-col'), o = e.key === 'ArrowRight' ? col.nextElementSibling : col.previousElementSibling, n = o && o.querySelector('.cr-cd');
                if (n) { e.preventDefault(); n.focus(); }
            }
        },
    },
};
</script>
